import BranchArrivalRatesPerHour from "../../../components/branches/reports/daily/BranchArrivalRatesPerHour";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const DailyBranchArrivalRatesPerHour = ({ showFilterForm = true, showTitle = 1 }) => (
  <DailyGeneratedReportPage
    branchScoped={true}
    reportTypeId={REPORT_TYPE_IDS.daily_branch_arrival_rates_per_hour}
    title="Branch Arrival Rates Per Hour"
    helmetTitle="Daily Branch Arrival Rates Per Hour"
    descriptionKey="BranchesArrivalRatesPerHour"
    columnDefinitions={ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS}
    defaultSortColumn="total"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) => (
      <BranchArrivalRatesPerHour
        data={data}
        renderConfig={renderConfig}
        onRenderConfigChange={onRenderConfigChange}
      />
    )}
  </DailyGeneratedReportPage>
);

export default DailyBranchArrivalRatesPerHour;
